"use client";

import { Button } from "@/components/ui/button";
import Briefcase from "lucide-react/dist/esm/icons/briefcase";
import ChevronRight from "lucide-react/dist/esm/icons/chevron-right";
import FileQuestion from "lucide-react/dist/esm/icons/file-question";

interface SellerAboutTabProps {
  seller: {
    display_name?: string | null;
    username?: string | null;
    hireable?: boolean;
    hire_starting_price?: number | null;
  };
  isOwnProfile: boolean;
  onHireClick: () => void;
  /** Buyer doesn't know what it should cost — let the seller quote instead. */
  onRequestQuoteClick: () => void;
}

export function SellerAboutTab({ seller, isOwnProfile, onHireClick, onRequestQuoteClick }: SellerAboutTabProps) {
  if (!seller.hireable || isOwnProfile) return null;

  return (
    <section className="rounded-2xl border border-primary/30 bg-primary/5 p-6 md:p-8 text-center">
      <h3 className="font-display text-lg md:text-xl font-bold mb-2">
        Need something custom?
      </h3>
      <p className="text-muted-foreground text-sm mb-4 max-w-md mx-auto">
        {seller.display_name || seller.username} is available for custom commissions with escrow-protected payments.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
        <Button onClick={onHireClick}>
          <Briefcase className="h-4 w-4 mr-2" />
          Start a Commission
          <ChevronRight className="h-4 w-4 ml-1" />
        </Button>
        {/* The other direction: you describe the job, they name the price.
            Most buyers have no idea what a custom map costs. */}
        <Button variant="outline" onClick={onRequestQuoteClick}>
          <FileQuestion className="h-4 w-4 mr-2" />
          Ask for a quote
        </Button>
      </div>
      <p className="mt-3 text-2xs text-muted-foreground">
        Start a commission if you know your budget · Ask for a quote if you want their price first
      </p>
    </section>
  );
}
